import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, renderList as _renderList } from "vue";
const _hoisted_1 = ["data-open"];
const _hoisted_2 = {
  class: "c-left brand"
};
const _hoisted_3 = {
  class: "configurator-body"
};
const _hoisted_4 = {
  class: "container"
};
const _hoisted_5 = {
  class: "settings"
};
const _hoisted_6 = {
  class: "c-right controls"
};
const _hoisted_7 = {
  class: "c-body"
};
const _hoisted_8 = {
  class: "expert"
};
const _hoisted_9 = {
  class: "support"
};
const _hoisted_10 = ["data-open"];
const _hoisted_11 = ["data-mobile", "data-open"];
const _hoisted_12 = ["data-full-width"];
const _hoisted_13 = {
  class: "configurator-body"
};
const _hoisted_14 = {
  key: 0,
  class: "container"
};
const _hoisted_15 = {
  key: 0
};
const _hoisted_16 = {
  key: 1
};
const _hoisted_17 = {
  class: "info"
};
const _hoisted_18 = {
  class: "ic close"
};
const _hoisted_19 = {
  key: 1,
  class: "container-product"
};
const _hoisted_20 = ["data-open"];
const _hoisted_21 = {
  class: "side-summary"
};
const _hoisted_22 = {
  class: "flex"
};
const _hoisted_23 = {
  class: "flex-body"
};
const _hoisted_24 = {
  class: "text-left"
};
const _hoisted_25 = {
  class: "localized-text"
};
const _hoisted_26 = {
  class: "list"
};
const _hoisted_27 = {
  class: "desc"
};
const _hoisted_28 = {
  class: "button-col"
};
const _hoisted_29 = ["data-text"];
const _hoisted_30 = {
  key: 0
};
const _hoisted_31 = {
  class: "desc"
};
const _hoisted_32 = {
  class: "button-col"
};
const _hoisted_33 = ["data-text"];
const _hoisted_34 = {
  key: 1
};
const _hoisted_35 = {
  class: "desc"
};
const _hoisted_36 = {
  class: "button-col"
};
const _hoisted_37 = ["data-text"];
const _hoisted_38 = {
  class: "flex confirm-box"
};
const _hoisted_39 = {
  class: "flex-body"
};
const _hoisted_40 = {
  class: "text-left"
};
const _hoisted_41 = {
  class: "localized-text"
};
const _hoisted_42 = {
  class: "footer"
};
const _hoisted_43 = ["data-text"];
const _hoisted_44 = ["data-text"];
const _hoisted_45 = {
  class: "flex"
};
const _hoisted_46 = {
  class: "flex-body"
};
const _hoisted_47 = {
  class: "text-left"
};
const _hoisted_48 = {
  class: "localized-text"
};
const _hoisted_49 = {
  class: "list list-row"
};
const _hoisted_50 = {
  class: "small"
};
const _hoisted_51 = ["data-text"];
const _hoisted_52 = {
  class: "flex"
};
const _hoisted_53 = {
  class: "flex-body"
};
const _hoisted_54 = {
  class: "text-left"
};
const _hoisted_55 = {
  class: "localized-text"
};
const _hoisted_56 = {
  class: "list"
};
const _hoisted_57 = {
  class: "desc-button"
};
const _hoisted_58 = {
  class: "button-col"
};
const _hoisted_59 = ["onClick"];
const _hoisted_60 = {
  class: "flex"
};
const _hoisted_61 = {
  class: "flex-body"
};
const _hoisted_62 = {
  class: "text-left"
};
const _hoisted_63 = {
  class: "localized-text"
};
const _hoisted_64 = {
  class: "list list-row"
};
const _hoisted_65 = ["data-text"];
const _hoisted_66 = {
  class: "flex confirm-box"
};
const _hoisted_67 = {
  class: "flex-body"
};
const _hoisted_68 = {
  class: "text-left"
};
const _hoisted_69 = {
  class: "footer"
};
const _hoisted_70 = ["data-text"];
const _hoisted_71 = {
  class: "flex confirm-box"
};
const _hoisted_72 = {
  class: "flex-body"
};
const _hoisted_73 = {
  class: "text-left"
};
const _hoisted_74 = {
  key: 0
};
const _hoisted_75 = {
  key: 1
};
const _hoisted_76 = {
  key: 2
};
const _hoisted_77 = {
  key: 3,
  class: "localized-text"
};
const _hoisted_78 = {
  key: 4,
  class: "localized-text"
};
const _hoisted_79 = {
  key: 5,
  class: "localized-text"
};
const _hoisted_80 = {
  class: "footer"
};
const _hoisted_81 = ["data-text"];
const _hoisted_82 = ["data-text"];
const _hoisted_83 = ["data-text"];
const _hoisted_84 = ["data-text"];
const _hoisted_85 = ["data-text"];
const _hoisted_86 = ["data-text"];
const _hoisted_87 = {
  class: "flex confirm-box"
};
const _hoisted_88 = {
  class: "flex-body"
};
const _hoisted_89 = {
  class: "text-left"
};
const _hoisted_90 = {
  class: "localized-text"
};
const _hoisted_91 = {
  class: "footer"
};
const _hoisted_92 = ["data-text"];
import { useLoginStore } from "@/stores/LoginStore";
import { ref, getCurrentInstance, onMounted, watch, onBeforeMount } from "vue";
import { ElButton, ElDialog } from "element-plus";
// ElNotification
import commonFooter from "./commonFooter.vue";
import searchProducts from "./searchProducts.vue";
import searchCode from "./searchCode.vue";
import productDetail from "./productDetail.vue";
import productSummary from "./productSummary.vue";
import { useOverlayStore } from "@/stores";
import { useAdditionalAttrStore } from "@/stores/AdditionalAttrStore";
import { configuratorIdStore } from "@/stores/configuratorIdStore";
import { copyClipboard, directLogout, handleBeforeUnload, handlePopstateUnload, handleRefresh, openFullLoading, openLoaderWhite, productReset, loadFont } from "@/utils/tools";
import { useConfiguratorStore } from "@/stores/configuratorData";
import { SetLanguageFromFile, SetParameter } from "@/api/obj.api";
import axios from "axios";
import { computed } from "vue";
import { configuratorOpenState } from "@/stores/configuratorOpenState";
import { useI18n } from "vue-i18n";
import { handleResetConfigurator } from "@/hooks/summary";
import SearchCodeByOrderCode from "./searchCodeByOrderCode.vue";
const textRefresh = "button.refresh";
const textRefresh2 = "button.refresh2";
export default /*@__PURE__*/_defineComponent({
  __name: 'OpenConfigurator',
  setup(__props) {
    const {
      eventBus,
      $i18n
    } = getCurrentInstance()?.appContext.config.globalProperties ?? {
      eventBus: undefined,
      $i18n: undefined
    };
    const additionalAttrStore = useAdditionalAttrStore();
    const loginStore = useLoginStore();
    const OverlayStore = useOverlayStore();
    const configuratorStore = useConfiguratorStore();
    const {
      t
    } = useI18n();
    const closeErrorModel = () => {
      if (OverlayStore.onCloseExit) {
        OverlayStore.closeError();
      } else {
        additionalAttrStore.clearCurrentModelCodeObj();
        const cis = configuratorIdStore();
        cis.clearBackData();
        directLogout();
      }
    };
    const cos = configuratorOpenState();
    watch(cos, nV => {
      if (nV.lng) {
        if ($i18n) {
          $i18n.locale = nV.lng;
        }
      }
    }, {
      deep: true,
      immediate: true
    });
    onBeforeMount(async () => {
      try {
        if (!configuratorStore.thumbnails || Date.now() >= (configuratorStore.thumbnailsExpiration ?? 0)) {
          const thumbnailsResponse = await axios.get(additionalAttrStore.getDataConfig.thumbnailsUrl);
          configuratorStore.thumbnails = thumbnailsResponse.data;
          const cacheDuration = additionalAttrStore.getDataConfig.thumbnailsJsonCacheTimeInSeconds;
          configuratorStore.thumbnailsExpiration = Date.now() + cacheDuration * 1000;
          console.log(additionalAttrStore.dataConfig.assetBaseUrl);
          if (additionalAttrStore.dataConfig.assetBaseUrl) {
            loadFont("ChivoMono", "ChivoMono-Regular", additionalAttrStore.dataConfig.assetBaseUrl);
            loadFont("iconfont", "iconfont", additionalAttrStore.dataConfig.assetBaseUrl);
            const preloadDiv = document.createElement("div");
            preloadDiv.style.fontFamily = "ChivoMono, iconfont";
            preloadDiv.style.position = "absolute";
            preloadDiv.style.opacity = "0";
            preloadDiv.style.pointerEvents = "none";
            preloadDiv.style.width = "0";
            preloadDiv.style.height = "0";
            preloadDiv.textContent = "preload";
            document.body.appendChild(preloadDiv);
            setTimeout(() => {
              document.body.removeChild(preloadDiv);
            }, 1000);
          }
        }
      } catch (error) {
        console.error("Failed loading thumbnails JSON.", error);
      }
    });
    const closeDailogVisible = computed(() => OverlayStore.getshowShortcodeError);
    // support helper
    const hotlineTelephone = ref(additionalAttrStore.config.hotlinePhone);
    const supportMailHandle = async () => {
      document.removeEventListener("keydown", handleRefresh);
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopstateUnload);
      const handleEvent = new CustomEvent("buttonClickMailHandle", {
        bubbles: true,
        detail: true
      });
      document.dispatchEvent(handleEvent);
      const res = await cis.getConfiguratorId();
      const shortcode = ref("");
      if (typeof res === "string") {
        shortcode.value = t(res);
      } else {
        shortcode.value = "";
        if (typeof res.data !== "undefined" && res.data.code !== "") {
          shortcode.value = res.data.code;
        }
      }
      let bodyTemplate = t("mail.body");
      let subject = t("mail.subject");
      if (shortcode.value) {
        subject = subject.replace("-buildcode-", shortcode.value);
        bodyTemplate = bodyTemplate.replace("-buildcode-", shortcode.value);
      }
      if (configuratorStore.getCurrentType) {
        bodyTemplate = bodyTemplate.replace("-modelcode-", configuratorStore.getCurrentType);
      }
      if (additionalAttrStore.dataConfig.environment) {
        bodyTemplate = bodyTemplate.replace("-type-", additionalAttrStore.dataConfig.environment);
      }
      location.href = "mailto:" + additionalAttrStore.config.mailSupport + "?subject=" + subject + "&body=" + bodyTemplate;
    };
    const supportChatHandle = async () => {
      console.log(additionalAttrStore.dataConfig);
      let BuildId = "";
      let OrderCode;
      const res = await configuratorIdStore().getConfiguratorId();
      if (typeof res !== "string") {
        if (res.data?.code) {
          BuildId = res.data.code;
        }
      }
      const contentType = additionalAttrStore.dataConfig.contentStringType;
      if (typeof contentType === "string") {
        if (contentType === "internal") {
          OrderCode = configuratorStore.apiConfiguratorResult?.ConfiguratorResult.CurrentState.CurrentCoding[0].ContentString;
        } else {
          OrderCode = configuratorStore.apiConfiguratorResult?.ConfiguratorResult.CurrentState.CurrentCoding[0].ContentStringPublic;
        }
      }
      const ArticleNumber = configuratorStore.getCurrentState?.CodeComplete ? configuratorStore.getResultData?.ItemInformation?.Item.ItemId : "";
      const Quantity = configuratorStore.getQuantity ? configuratorStore.getQuantity : additionalAttrStore.getDataConfig.qty;
      const dataToHost = {
        buildId: BuildId,
        OrderCode: OrderCode,
        ArticleNumber: ArticleNumber,
        CustomerId: additionalAttrStore.dataConfig.customerNumber,
        Quantity: Quantity,
        Configuration: configuratorStore.getCurrentState
      };
      const handleEvent = new CustomEvent("buttonClickStartChat", {
        bubbles: true,
        detail: {
          close: directLogout,
          data: dataToHost,
          environment: additionalAttrStore.dataConfig.environment
        }
      });
      document.dispatchEvent(handleEvent);
    };
    // const emit = defineEmits(["switchMainProduct"]);
    const openTelephone = () => {
      window.open(`tel:${hotlineTelephone.value}`);
    };
    const handleSelect = item => {
      showToggleMode.value = false;
      additionalAttrStore.clearCurrentModelCodeObj();
      additionalAttrStore.setConfigByItem(item);
      if (!layoutMain.value) {
        const loading = openFullLoading(false, t("text.loading"));
        configuratorStore.setSelectedConfig().then(() => {
          loading.close();
        });
      }
      switchMainProduct();
      additionalAttrStore.hideToggleMode();
    };
    // view expert
    const viewExpert = ref(false);
    async function setExpertViewEnabled(enabled) {
      const loading = openFullLoading(false, t("text.loading"));
      viewExpert.value = enabled;
      const viewText = enabled ? "expert" : "standard";
      await SetParameter("configuratorview", enabled ? 1 : 2);
      await configuratorStore.initilizeConfigurator();
      if (configuratorStore.getCurrentType) {
        await configuratorStore.ChangeAssembly(configuratorStore.getCurrentType);
      }
      const handleEvent = new CustomEvent("configuratorViewChanged", {
        bubbles: true,
        detail: viewText
      });
      document.dispatchEvent(handleEvent);
      loading.close();
    }
    // layout display.
    const layoutMain = ref(true);
    const layoutProducts = ref(false);
    const visibleMessage = ref(true);
    watch(layoutProducts, () => {
      if (layoutProducts.value == true) {
        document.addEventListener("keydown", handleRefresh);
        window.addEventListener("beforeunload", handleBeforeUnload);
        window.addEventListener("popstate", handlePopstateUnload);
      } else {
        document.removeEventListener("keydown", handleRefresh);
        window.removeEventListener("beforeunload", handleBeforeUnload);
        window.removeEventListener("popstate", handlePopstateUnload);
      }
    });
    const showExitCalled = computed(() => {
      return additionalAttrStore.dataConfig.showExitWarning;
    });
    watch(showExitCalled, () => {
      if (showExitCalled.value && layoutProducts.value == true) {
        console.log("register: showExit if add", showExitCalled.value);
        document.addEventListener("keydown", handleRefresh);
        window.addEventListener("beforeunload", handleBeforeUnload);
        window.addEventListener("popstate", handlePopstateUnload);
      } else {
        console.log("register: showExit else remove", showExitCalled.value);
        document.removeEventListener("keydown", handleRefresh);
        window.removeEventListener("beforeunload", handleBeforeUnload);
        window.removeEventListener("popstate", handlePopstateUnload);
      }
    });
    const visibleRefresh = computed(() => {
      if (layoutProducts.value == false) {
        return false;
      }
      if (additionalAttrStore.dataConfig.displayDeviceController) {
        if (typeof additionalAttrStore.dataConfig.Id === "string" || typeof additionalAttrStore.dataConfig.Id === "object") {
          return true;
        }
        if (additionalAttrStore.singleProduct) {
          return false;
        }
        return layoutProducts.value;
      }
      if (additionalAttrStore.dataConfig.modelVariants && additionalAttrStore.dataConfig.modelVariants.length) {
        return true;
      }
      return false;
    });
    const showToggleMode = ref(false);
    const diffRefreshText = computed(() => {
      let thisText = textRefresh2;
      if (additionalAttrStore.dataConfig.modelVariants !== undefined && additionalAttrStore.dataConfig.modelVariants.length) {
        thisText = textRefresh;
      }
      return thisText;
    });
    const helpTextVisble = computed(() => {
      if (additionalAttrStore.dataConfig.environment == "CustomerPortal") {
        if (additionalAttrStore.dataConfig.Id || visibleRefresh.value) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    });
    const toggleModeModel = computed(() => {
      if (additionalAttrStore.dataConfig.modelVariants !== undefined && additionalAttrStore.dataConfig.modelVariants.length && showToggleMode.value) {
        return true;
      } else {
        return false;
      }
    });
    const confirmCloseCalled = computed(() => OverlayStore.getconfirmCloseCalled);
    watch(confirmCloseCalled, newValue => {
      if (newValue) {
        OverlayStore.setconfirmCloseCalled(false);
        resetMainProduct();
      }
    });
    const closeModeModel = () => {
      if (layoutMain.value == true) {
        directLogout();
        OverlayStore.closeOverlay();
      } else {
        showToggleMode.value = false;
      }
    };
    // dialog visible control
    // const visibleSupport = ref(false);
    const visibleLogout = ref(false);
    const visibleSupportHotline = ref(false);
    const visibleProductControl = ref(false);
    const visibleAdminWidget = ref(false);
    const isMobile = ref(false);
    const isMobileVisible = ref(false);
    const showHelpMessage = () => {
      // visibleSupport.value = !visibleSupport.value;
      // OverlayStore.toggleOverlay();
      OverlayStore.showVisibleSupport();
      const handleEvent = new CustomEvent("showHelpMessage", {
        bubbles: true,
        detail: true
      });
      document.dispatchEvent(handleEvent);
    };
    // default test values
    const hotlineInput = ref("");
    const hotlineNotice = ref("");
    const languageInput = ref("");
    const regionInput = ref("");
    const planInput = ref("");
    const cis = configuratorIdStore();
    const callSupportHotlineHandle = async () => {
      visibleSupportHotline.value = !visibleSupportHotline.value;
      const res = await cis.getConfiguratorId();
      if (typeof res === "string") {
        hotlineNotice.value = t(res);
      } else {
        hotlineNotice.value = "";
        if (typeof res.data !== "undefined" && res.data.code !== "") {
          hotlineInput.value = res.data.code;
        }
      }
    };
    const copyHotlineHandle = () => {
      if (hotlineInput.value !== "") copyClipboard(hotlineInput.value);
    };
    const saveadminwidget = async () => {
      const loading = openFullLoading(false, t("text.loading"));
      if (regionInput.value && configuratorStore.adminParams.regionInput != regionInput.value) {
        await SetParameter("region", regionInput.value);
      }
      if (languageInput.value && configuratorStore.adminParams.languageInput != languageInput.value) {
        await SetParameter("language", languageInput.value);
        additionalAttrStore.setLang(languageInput.value);
        additionalAttrStore.setApiLang(languageInput.value);
        SetLanguageFromFile(languageInput.value);
        const status = await configuratorStore.getCodestatus();
        if (status) {
          await configuratorStore.setResults();
        }
      }
      if (planInput.value && configuratorStore.adminParams.planInput != planInput.value) {
        await SetParameter("plannumber", planInput.value);
      }
      const AdminParamsArr = {
        languageInput: languageInput.value,
        regionInput: regionInput.value,
        planInput: planInput.value
      };
      if (JSON.stringify(AdminParamsArr) != JSON.stringify(configuratorStore.adminParams)) {
        configuratorStore.setAdminParams(AdminParamsArr);
        await configuratorStore.initilizeConfigurator();
        if (configuratorStore.getCurrentState) {
          await configuratorStore.setSelectedConfig();
        }
      }
      visibleAdminWidget.value = false;
      loading.close();
    };
    function handleLogout() {
      directLogout();
      eventBus.emit("logoutConfigurator", true);
    }
    const handleClose = () => {
      visibleMessage.value = false;
    };
    setTimeout(handleClose, 5000);
    function checkIframeLoaded() {
      const iframe = document.querySelector("iframe");
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.location.reload();
      }
    }
    const handleProductLayout = () => {
      if (!isMobile.value) {
        visibleProductControl.value = !visibleProductControl.value;
        if (visibleProductControl.value) {
          eventBus.emit("setFullContainer", "half");
        } else {
          eventBus.emit("setFullContainer", "full");
        }
      } else {
        isMobileVisible.value = !isMobileVisible.value;
        setTimeout(checkIframeLoaded, 1000);
      }
    };
    /**
     * open product
     */
    const switchMainProduct = () => {
      // hide main layout
      layoutMain.value = false;
      // display product layout
      layoutProducts.value = true;
      // visible product control
      visibleProductControl.value = true;
    };
    /**
     * show main page.
     */
    async function resetMainProduct(args) {
      eventBus.emit("resetImageSelector", true);
      eventBus.emit("resetSelectedOptionalCertificate", true);
      const dvs = additionalAttrStore.getDataConfig.displayViewSwitch;
      const saw = additionalAttrStore.getDataConfig.showAdministratorWidget;
      const env = additionalAttrStore.getDataConfig.environment;
      const ddc = additionalAttrStore.getDataConfig.displayDeviceController;
      const aud = additionalAttrStore.getDataConfig.autoUpdateDrawings;
      const showPrice = additionalAttrStore.getDataConfig.showPricing;
      const stockOnHand = additionalAttrStore.getDataConfig.stockOnHandVisible;
      const isPriceDetailsVisible = additionalAttrStore.getDataConfig.isPriceDetailsVisible;
      const isDeliveryDateExp = additionalAttrStore.getDataConfig.isDeliveryDateExp;
      const displayDispatchInformation = additionalAttrStore.getDataConfig.displayDispatchInformation;
      const defaultConfig = cis.tmpConfig;
      const lang = additionalAttrStore.langValue;
      const langApi = additionalAttrStore.getLangApi;
      const hideAssemblies = additionalAttrStore.getDataConfig.hideAssemblies ?? false;
      const showOptionId = additionalAttrStore.getDataConfig.showOptionId ?? false;
      const contentStringType = additionalAttrStore.getDataConfig.contentStringType;
      const noPriceAvailableText = additionalAttrStore.getDataConfig.noPriceAvailableText ? additionalAttrStore.getDataConfig.noPriceAvailableText : "";
      const assetBaseUrl = additionalAttrStore.getDataConfig.assetBaseUrl;
      const shellModels = additionalAttrStore.getDataConfig.shellModels ?? [];
      const loginName = additionalAttrStore.getDataConfig.loginName;
      productReset();
      const loading = openLoaderWhite(false, t("text.loading"));
      if (args === "summary") {
        layoutMain.value = false;
        layoutProducts.value = true;
        visibleProductControl.value = true;
      } else {
        layoutMain.value = true;
        layoutProducts.value = false;
        visibleProductControl.value = false;
      }
      if (defaultConfig) {
        additionalAttrStore.setCommmunicationConfigs(defaultConfig);
      }
      additionalAttrStore.setLang(lang);
      additionalAttrStore.setApiLang(langApi);
      additionalAttrStore.setDisplayViewSwitch(dvs);
      additionalAttrStore.setShowAdministratorWidget(saw);
      additionalAttrStore.setEnviroment(env);
      additionalAttrStore.setdisplayDeviceController(ddc);
      additionalAttrStore.setautoUpdateDrawings(aud);
      additionalAttrStore.setShowPricing(showPrice);
      additionalAttrStore.setIsPriceDetailsVisible(isPriceDetailsVisible);
      additionalAttrStore.setIsDeliveryDateExp(isDeliveryDateExp);
      additionalAttrStore.setDisplayDispatchInformation(displayDispatchInformation);
      additionalAttrStore.setStockOnHandVisible(stockOnHand);
      additionalAttrStore.sethideAssemblies(hideAssemblies);
      additionalAttrStore.setshowOptionId(showOptionId);
      additionalAttrStore.setContentStringType(contentStringType);
      additionalAttrStore.setNoPriceAvailableText(noPriceAvailableText);
      additionalAttrStore.setAssetBaseUrl(assetBaseUrl);
      additionalAttrStore.setShellModels(shellModels);
      additionalAttrStore.setLoginName(loginName);
      configuratorStore.initilizeConfigurator();
      const uos = useOverlayStore();
      uos.closeloading();
      if (args === "summary") {
        await configuratorStore.setSelectedConfig();
      }
      loading.close();
    }
    eventBus.on("logoutConfigurator", res => {
      if (res) {
        layoutMain.value = true;
        layoutProducts.value = false;
        visibleProductControl.value = false;
        document.body.classList.remove("wika-dialog-open");
        document.documentElement.classList.remove("konfig-popup-hidden");
        eventBus.emit("logoutConfigurator", false);
      }
    });
    const refRightContent = ref();
    const winWidth = ref(0);
    const getWindowResize = () => {
      winWidth.value = window.innerWidth;
    };
    onMounted(async () => {
      window.addEventListener("resize", getWindowResize);
      getWindowResize();
      if (additionalAttrStore.getCommunicationConfig.welcomeMessage) {
        visibleMessage.value = true;
      } else {
        visibleMessage.value = false;
      }
      if (OverlayStore.showProductDetailpage) {
        if (loginStore.isLoggedIn) {
          switchMainProduct();
        } else {
          await loginStore.LoginToStore();
          switchMainProduct();
        }
      }
      if (additionalAttrStore.dataConfig.modelVariants !== undefined && additionalAttrStore.dataConfig.modelVariants.length) {
        showToggleMode.value = true;
      }
    });
    watch(winWidth, val => {
      if (val < 992) {
        if (!isMobile.value) {
          isMobile.value = true;
          additionalAttrStore.setIsMobile(true);
        }
      } else {
        if (isMobile.value) {
          isMobile.value = false;
          additionalAttrStore.setIsMobile(false);
        }
      }
    }, {
      immediate: true
    });
    const logoClick = () => {
      eventBus.emit("logoClickHandle", visibleProductControl.value);
      if (additionalAttrStore.dataConfig.modelVariants !== undefined && additionalAttrStore.dataConfig.modelVariants.length) {
        showToggleMode.value = true;
      } else {
        if (layoutProducts.value) {
          OverlayStore.setConfirmClose(true, "switch");
        }
      }
    };
    const AdministratorWidgetClick = () => {
      const initialAdminVals = {
        languageInput: "",
        regionInput: "",
        planInput: ""
      };
      const loading = openFullLoading(false, t("text.loading"));
      eventBus.emit("logoClickHandle", visibleProductControl.value);
      if (!configuratorStore.apiContent) {
        configuratorStore.initilizeConfigurator();
      }
      visibleAdminWidget.value = true;
      configuratorStore.getRegion?.forEach(v => {
        if (v.Selected) {
          initialAdminVals.regionInput = v.Id;
          regionInput.value = v.Id;
        }
      });
      configuratorStore.getPlannumbers?.forEach(v => {
        if (v.Selected) {
          initialAdminVals.planInput = v.Id;
          planInput.value = v.Id;
        }
      });
      configuratorStore.getLanguages?.forEach(v => {
        if (v.Selected) {
          initialAdminVals.languageInput = v.Id;
          languageInput.value = v.Id;
        }
      });
      configuratorStore.setAdminParams(initialAdminVals);
      loading.close();
    };
    // error occured
    document.addEventListener("errorOccured", function (event) {
      if (event.detail !== undefined) {
        console.log("errorOccured", event.detail);
        if (event.detail.event === "getInitData") {
          directLogout();
          eventBus.emit("logoutConfigurator", true);
        }
      }
    });
    watch(() => OverlayStore.showProductDetailpage, (newId, oldId) => {
      if (newId !== oldId) {
        switchMainProduct();
      }
    });
    const completed = computed(() => configuratorStore.getCurrentState?.CodeComplete);
    /**
    async function showSuccess() {
      return setTimeout(() => {
        ElNotification({
          title: "Success",
          message: "Code Completed Successfully",
          type: "success",
        });
      }, 500);
    }
    */
    watch(completed, async (newValue, oldValue) => {
      if (newValue !== oldValue && newValue) {
        if (!configuratorStore.isGetResultsCalled) {
          await configuratorStore.setResults();
          configuratorStore.setIsGetResultsCalled(true);
        }
        eventBus.emit("showMore", true);
      }
    });
    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_affix = _resolveComponent("el-affix");
      const _component_ElCol = _resolveComponent("ElCol");
      const _component_ElRow = _resolveComponent("ElRow");
      const _component_productFixedBottom = _resolveComponent("productFixedBottom");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_alert = _resolveComponent("el-alert");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_unref(ElDialog), {
        modelValue: _unref(OverlayStore).isVisible,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _unref(OverlayStore).isVisible = $event),
        "destroy-on-close": "",
        "show-close": false,
        fullscreen: true,
        "close-on-press-escape": false,
        id: "overlay"
      }, {
        header: _withCtx(() => [_createVNode(_component_el_affix, {
          offset: 0,
          style: _normalizeStyle({
            width: winWidth.value + 'px'
          })
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "configurator-header configurator-layout",
            "data-open": isMobileVisible.value
          }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_svg_icon, {
            "icon-class": "logo-blue",
            "class-name": "logo"
          }), visibleRefresh.value ? (_openBlock(), _createBlock(_unref(ElButton), {
            key: 0,
            type: "primary",
            onClick: logoClick,
            round: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_svg_icon, {
              "icon-class": "icon-refresh-black",
              "class-name": "refresh"
            }), _createElementVNode("span", null, _toDisplayString(_unref(t)(diffRefreshText.value)), 1)]),
            _: 1
          })) : _createCommentVNode("", true)])])])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_unref(additionalAttrStore).getDataConfig.displayViewSwitch ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createElementVNode("span", {
            class: _normalizeClass(viewExpert.value ? 'active' : ''),
            onClick: _cache[0] || (_cache[0] = $event => setExpertViewEnabled(true))
          }, [_createVNode(_component_svg_icon, {
            "icon-class": "toggle-view",
            "class-name": "toggle-view"
          }), _createElementVNode("span", null, _toDisplayString(_ctx.$t("button.expert")), 1)], 2), _cache[27] || (_cache[27] = _createElementVNode("span", {
            class: "split"
          }, "|", -1)), _createElementVNode("span", {
            "data-type": "standard",
            class: _normalizeClass(viewExpert.value ? '' : 'active'),
            onClick: _cache[1] || (_cache[1] = $event => setExpertViewEnabled(false))
          }, [_createElementVNode("span", null, _toDisplayString(_ctx.$t("button.standard")), 1), _createVNode(_component_svg_icon, {
            "icon-class": "toggle-view",
            "class-name": "toggle-view"
          })], 2)], 64)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_9, [_unref(additionalAttrStore).getDataConfig.showAdministratorWidget ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: AdministratorWidgetClick
          }, [_createVNode(_component_el_tooltip, {
            content: _ctx.$t('header.adminwidgetTooltip')
          }, {
            default: _withCtx(() => [_createVNode(_component_el_link, {
              class: "white"
            }, {
              default: _withCtx(() => [...(_cache[28] || (_cache[28] = [_createElementVNode("i", {
                class: "iconfont icon-setting"
              }, null, -1)]))]),
              _: 1
            })]),
            _: 1
          }, 8, ["content"])])) : _createCommentVNode("", true), _createVNode(_component_el_tooltip, {
            content: _ctx.$t('header.requestSupport')
          }, {
            default: _withCtx(() => [_withDirectives(_createVNode(_component_el_link, {
              onClick: _cache[3] || (_cache[3] = $event => showHelpMessage())
            }, {
              default: _withCtx(() => [_createVNode(_component_svg_icon, {
                "icon-class": "support",
                "class-name": "support",
                onClick: _cache[2] || (_cache[2] = $event => showHelpMessage())
              })]),
              _: 1
            }, 512), [[_vShow, helpTextVisble.value]])]),
            _: 1
          }, 8, ["content"])]), layoutProducts.value ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "product-control",
            "data-open": visibleProductControl.value,
            onClick: handleProductLayout
          }, [_createVNode(_component_el_tooltip, {
            content: visibleProductControl.value ? _ctx.$t('header.sidebarCollapse') : _ctx.$t('header.sidebarExpand')
          }, {
            default: _withCtx(() => [_createVNode(_component_el_link, null, {
              default: _withCtx(() => [...(_cache[29] || (_cache[29] = [_createElementVNode("i", {
                class: "iconfont icon-double-arrow"
              }, null, -1)]))]),
              _: 1
            })]),
            _: 1
          }, 8, ["content"])], 8, _hoisted_10)) : _createCommentVNode("", true), _createVNode(_component_el_link, {
            onClick: _cache[4] || (_cache[4] = $event => visibleLogout.value = !visibleLogout.value),
            class: "white close"
          }, {
            default: _withCtx(() => [...(_cache[30] || (_cache[30] = [_createElementVNode("i", {
              class: "iconfont icon-close"
            }, null, -1)]))]),
            _: 1
          })])])], 8, _hoisted_1)]),
          _: 1
        }, 8, ["style"])]),
        default: _withCtx(() => [_createElementVNode("div", {
          class: "configurator-layout",
          "data-mobile": isMobile.value,
          "data-open": isMobileVisible.value
        }, [_createElementVNode("div", {
          class: "c-left",
          "data-full-width": !visibleProductControl.value
        }, [_createElementVNode("div", _hoisted_13, [layoutMain.value ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_14, [_createVNode(searchProducts, {
          onSwitchMainProduct: switchMainProduct
        }), _unref(additionalAttrStore).dataConfig.manualOrdercodeEdit ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createVNode(_component_ElRow, null, {
          default: _withCtx(() => [_createVNode(_component_ElCol, {
            span: 12,
            class: "search-code-form"
          }, {
            default: _withCtx(() => [_createVNode(searchCode, {
              onSwitchMainProduct: switchMainProduct
            })]),
            _: 1
          }), _createVNode(_component_ElCol, {
            span: 12,
            class: "search-code-form"
          }, {
            default: _withCtx(() => [_createVNode(SearchCodeByOrderCode, {
              onSwitchMainProduct: switchMainProduct
            })]),
            _: 1
          })]),
          _: 1
        })])) : (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(searchCode, {
          onSwitchMainProduct: switchMainProduct
        })])), _withDirectives(_createElementVNode("div", {
          class: _normalizeClass(visibleMessage.value ? 'message' : 'message hidden')
        }, [_cache[32] || (_cache[32] = _createElementVNode("div", {
          class: "ic"
        }, [_createElementVNode("i", {
          class: "iconfont icon-info"
        })], -1)), _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(additionalAttrStore).getCommunicationConfig.welcomeMessage), 1), _createElementVNode("div", _hoisted_18, [_createVNode(_component_el_link, {
          onClick: _cache[5] || (_cache[5] = $event => visibleMessage.value = !visibleMessage.value)
        }, {
          default: _withCtx(() => [...(_cache[31] || (_cache[31] = [_createElementVNode("i", {
            class: "iconfont icon-close"
          }, null, -1)]))]),
          _: 1
        })])], 2), [[_vShow, _unref(additionalAttrStore).getCommunicationConfig.welcomeMessage]])], 512)), [[_vShow, _unref(additionalAttrStore).dataConfig.displayDeviceController == true]]) : _createCommentVNode("", true), layoutProducts.value ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createVNode(productDetail, {
          refRightContent: refRightContent.value
        }, null, 8, ["refRightContent"]), _createVNode(_component_productFixedBottom)])) : _createCommentVNode("", true)]), _createVNode(commonFooter, {
          layoutProducts: layoutProducts.value
        }, null, 8, ["layoutProducts"])], 8, _hoisted_12), _createElementVNode("div", {
          class: "c-right",
          "data-open": visibleProductControl.value,
          ref_key: "refRightContent",
          ref: refRightContent
        }, [_createElementVNode("div", _hoisted_21, [_createVNode(productSummary, {
          onSwitchMainProduct: switchMainProduct,
          onResetMainProduct: resetMainProduct
        })])], 8, _hoisted_20)], 8, _hoisted_11)]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_unref(ElDialog), {
        modelValue: _unref(OverlayStore).visibleSupport,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _unref(OverlayStore).visibleSupport = $event),
        "destroy-on-close": "",
        "close-on-press-escape": false,
        "show-close": true,
        "append-to-body": true,
        "modal-class": "configurator-popup",
        width: "808px",
        center: true
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_22, [_cache[36] || (_cache[36] = _createElementVNode("div", {
          class: "ic"
        }, [_createElementVNode("i", {
          class: "iconfont icon-info"
        })], -1)), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t("header.helpLink")), 1), _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t("text.dialog.helper")), 1)]), _createElementVNode("ul", _hoisted_26, [_withDirectives(_createElementVNode("li", null, [_createElementVNode("div", _hoisted_27, [_createElementVNode("h4", null, _toDisplayString(_ctx.$t("header.dialog.mailSupport")), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t("text.dialog.mailSupport")), 1)]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", {
          class: "wikaButtonConf",
          "data-colour": "blue",
          "data-no-border": "",
          onClick: supportMailHandle,
          "data-text": _ctx.$t('button.dialog.mailButton'),
          id: "supportMailButton",
          "data-type": "button"
        }, [_cache[33] || (_cache[33] = _createElementVNode("i", {
          class: "iconfont icon-mail"
        }, null, -1)), _createTextVNode(" " + _toDisplayString(_ctx.$t("button.dialog.mailButton")), 1)], 8, _hoisted_29)])], 512), [[_vShow, _unref(additionalAttrStore).dataConfig.supportEmail && _unref(configuratorStore).getCurrentType]]), _unref(additionalAttrStore).dataConfig.supportChat ? (_openBlock(), _createElementBlock("li", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_createElementVNode("h4", null, _toDisplayString(_ctx.$t("header.dialog.chatSupport")), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t("text.dialog.chatSupport")), 1)]), _createElementVNode("div", _hoisted_32, [_createElementVNode("div", {
          class: "wikaButtonConf",
          "data-colour": "blue",
          "data-no-border": "",
          id: "supportChatButton",
          onClick: supportChatHandle,
          "data-text": _ctx.$t('button.dialog.startChat'),
          "data-type": "button"
        }, [_cache[34] || (_cache[34] = _createElementVNode("i", {
          class: "iconfont icon-chat"
        }, null, -1)), _createTextVNode(" " + _toDisplayString(_ctx.$t("button.dialog.startChat")), 1)], 8, _hoisted_33)])])) : _createCommentVNode("", true), _unref(additionalAttrStore).dataConfig.supportPhone ? (_openBlock(), _createElementBlock("li", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createElementVNode("h4", null, _toDisplayString(_ctx.$t("header.dialog.hotlineSupport")), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t("text.dialog.hotlineSupport")), 1)]), _createElementVNode("div", _hoisted_36, [_createElementVNode("div", {
          class: "wikaButtonConf",
          "data-colour": "blue",
          "data-no-border": "",
          id: "supportHotlineButton",
          onClick: callSupportHotlineHandle,
          "data-text": _ctx.$t('button.dialog.supportHotline'),
          "data-type": "button"
        }, [_cache[35] || (_cache[35] = _createElementVNode("i", {
          class: "iconfont icon-phone"
        }, null, -1)), _createTextVNode(" " + _toDisplayString(_ctx.$t("button.dialog.supportHotline")), 1)], 8, _hoisted_37)])])) : _createCommentVNode("", true)])])])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_unref(ElDialog), {
        modelValue: visibleLogout.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => visibleLogout.value = $event),
        "destroy-on-close": "",
        "close-on-press-escape": false,
        "show-close": true,
        "append-to-body": true,
        "modal-class": "configurator-popup",
        width: "808px",
        center: true
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_38, [_cache[37] || (_cache[37] = _createElementVNode("div", {
          class: "ic"
        }, [_createElementVNode("i", {
          class: "iconfont icon-info"
        })], -1)), _createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t("header.logout")), 1), _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t("label.areyoulogout")), 1)]), _createElementVNode("div", _hoisted_42, [_createElementVNode("div", {
          class: "wikaButtonConf",
          "data-colour": "white",
          "data-no-border": "",
          onClick: _cache[8] || (_cache[8] = $event => visibleLogout.value = !visibleLogout.value),
          "data-text": _ctx.$t('button.cancel'),
          "data-type": "button"
        }, _toDisplayString(_ctx.$t("button.cancel")), 9, _hoisted_43), _createElementVNode("div", {
          class: "wikaButtonConf",
          "data-colour": "blue",
          "data-no-border": "",
          onClick: handleLogout,
          "data-text": _ctx.$t('button.ok'),
          "data-type": "button"
        }, _toDisplayString(_ctx.$t("button.exit")), 9, _hoisted_44)])])])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_unref(ElDialog), {
        modelValue: visibleSupportHotline.value,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => visibleSupportHotline.value = $event),
        "destroy-on-close": "",
        "close-on-press-escape": false,
        "show-close": true,
        "append-to-body": true,
        "modal-class": "configurator-popup",
        width: "808px",
        center: true
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_45, [_cache[40] || (_cache[40] = _createElementVNode("div", {
          class: "ic"
        }, [_createElementVNode("i", {
          class: "iconfont icon-info"
        })], -1)), _createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t("header.dialog.hotlineSupport")), 1), _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.$t("text.dialog.hotline")), 1)]), _createElementVNode("ul", _hoisted_49, [_createElementVNode("li", null, [_createVNode(_component_el_input, {
          modelValue: hotlineInput.value,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => hotlineInput.value = $event),
          onClick: copyHotlineHandle,
          readonly: ""
        }, null, 8, ["modelValue"]), hotlineNotice.value !== '' ? (_openBlock(), _createBlock(_component_el_alert, {
          key: 0,
          title: hotlineNotice.value,
          type: "error",
          closable: false
        }, null, 8, ["title"])) : _createCommentVNode("", true)]), _createElementVNode("li", null, [_createElementVNode("h3", null, [_createTextVNode(_toDisplayString(_ctx.$t("header.dialog.hotlineSupport")) + ": ", 1), _cache[38] || (_cache[38] = _createElementVNode("br", null, null, -1)), _createTextVNode(" " + _toDisplayString(hotlineTelephone.value) + " * ", 1)]), _createElementVNode("p", _hoisted_50, "* " + _toDisplayString(_ctx.$t("text.dialog.hotlineSummary")), 1)]), _createElementVNode("li", null, [_createElementVNode("div", {
          class: "wikaButtonConf",
          "data-colour": "blue",
          "data-no-border": "",
          id: "hotlineButton",
          "data-text": _ctx.$t('button.dialog.hotlineButton'),
          "data-type": "button",
          onClick: openTelephone
        }, [_cache[39] || (_cache[39] = _createElementVNode("i", {
          class: "iconfont icon-phone"
        }, null, -1)), _createTextVNode(" " + _toDisplayString(_ctx.$t("button.dialog.hotlineButton")), 1)], 8, _hoisted_51)])])])])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_unref(ElDialog), {
        modelValue: toggleModeModel.value,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => toggleModeModel.value = $event),
        "destroy-on-close": "",
        "close-on-press-escape": false,
        "show-close": true,
        "append-to-body": true,
        "modal-class": "configurator-popup popup-fill",
        width: "808px",
        onClose: closeModeModel,
        center: true
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_52, [_cache[41] || (_cache[41] = _createElementVNode("div", {
          class: "ic"
        }, [_createElementVNode("i", {
          class: "iconfont icon-info"
        })], -1)), _createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t("label.hintLablel")), 1), _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.$t("label.hintText")), 1)]), _createElementVNode("ul", _hoisted_56, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(additionalAttrStore).dataConfig.modelVariants, (modelcode, key) => {
          return _openBlock(), _createElementBlock("li", {
            key: key
          }, [_createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_57, [_createElementVNode("h4", null, _toDisplayString(modelcode.dispayTitle), 1), _createElementVNode("p", null, _toDisplayString(modelcode.displayText), 1)])]),
              _: 2
            }, 1024), _createVNode(_component_el_col, {
              span: 6
            }), _createVNode(_component_el_col, {
              span: 6
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_58, [_createElementVNode("div", {
                class: "wikaButtonConf",
                "data-colour": "blue",
                "data-no-border": "",
                "data-type": "button",
                onClick: $event => handleSelect({
                  Id: modelcode.model,
                  Selected: true
                })
              }, _toDisplayString(_ctx.$t("button.dialog.toggleModelButton")), 9, _hoisted_59)])]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024)]);
        }), 128))])])])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_unref(ElDialog), {
        modelValue: visibleAdminWidget.value,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => visibleAdminWidget.value = $event),
        "destroy-on-close": "",
        "close-on-press-escape": false,
        "show-close": true,
        "append-to-body": true,
        "modal-class": "configurator-popup",
        width: "808px",
        center: true
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_60, [_cache[45] || (_cache[45] = _createElementVNode("div", {
          class: "ic"
        }, [_createElementVNode("i", {
          class: "iconfont icon-info"
        })], -1)), _createElementVNode("div", _hoisted_61, [_createElementVNode("div", _hoisted_62, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t("header.dialog.adminwidget")), 1), _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.$t("text.dialog.adminwidget")), 1)]), _createElementVNode("ul", _hoisted_64, [_createElementVNode("li", null, [_createElementVNode("h3", null, [_createTextVNode(_toDisplayString(_ctx.$t("header.dialog.Languages")) + ": ", 1), _cache[42] || (_cache[42] = _createElementVNode("br", null, null, -1))]), _createVNode(_component_el_select, {
          modelValue: languageInput.value,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => languageInput.value = $event),
          placeholder: _ctx.$t('label.adminlanguageInputPlaceholder'),
          size: "large",
          style: {
            "width": "240px"
          }
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(configuratorStore).getLanguages, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.Id,
              label: item.Text,
              value: item.Id
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue", "placeholder"]), _createElementVNode("h3", null, [_createTextVNode(_toDisplayString(_ctx.$t("header.dialog.region")) + ": ", 1), _cache[43] || (_cache[43] = _createElementVNode("br", null, null, -1))]), _createVNode(_component_el_select, {
          modelValue: regionInput.value,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => regionInput.value = $event),
          placeholder: _ctx.$t('label.adminregionInputPlaceholder'),
          size: "large",
          style: {
            "width": "240px"
          }
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(configuratorStore).getRegion, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.Id,
              label: item.Text,
              value: item.Id
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue", "placeholder"]), _createElementVNode("h3", null, [_createTextVNode(_toDisplayString(_ctx.$t("header.dialog.plan")) + ": ", 1), _cache[44] || (_cache[44] = _createElementVNode("br", null, null, -1))]), _createVNode(_component_el_select, {
          modelValue: planInput.value,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => planInput.value = $event),
          placeholder: _ctx.$t('label.adminplanInputPlaceholder'),
          size: "large",
          style: {
            "width": "240px"
          }
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(configuratorStore).getPlannumbers, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.Id,
              label: item.Text,
              value: item.Id
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue", "placeholder"])]), _createElementVNode("li", null, [_createElementVNode("div", {
          class: "wikaButtonConf",
          "data-colour": "blue",
          "data-no-border": "",
          onClick: saveadminwidget,
          "data-text": _ctx.$t('button.dialog.adminwidgetButton'),
          "data-type": "button"
        }, _toDisplayString(_ctx.$t("button.dialog.adminwidgetButton")), 9, _hoisted_65)])])])])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_unref(ElDialog), {
        modelValue: _unref(OverlayStore).IsError,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => _unref(OverlayStore).IsError = $event),
        "destroy-on-close": "",
        "close-on-press-escape": false,
        "show-close": true,
        "append-to-body": true,
        "modal-class": "configurator-popup",
        width: "808px",
        center: true,
        onClosed: closeErrorModel
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_66, [_cache[46] || (_cache[46] = _createElementVNode("div", {
          class: "ic"
        }, [_createElementVNode("i", {
          class: "iconfont icon-info"
        })], -1)), _createElementVNode("div", _hoisted_67, [_createElementVNode("div", _hoisted_68, [_createElementVNode("h3", null, _toDisplayString(_unref(OverlayStore).getErrorText), 1)]), _createElementVNode("div", _hoisted_69, [_createElementVNode("div", {
          class: "wikaButtonConf",
          "data-colour": "blue",
          "data-no-border": "",
          "data-text": _ctx.$t('button.ok'),
          "data-type": "button",
          onClick: closeErrorModel
        }, _toDisplayString(_ctx.$t("button.ok")), 9, _hoisted_70)])])])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_unref(ElDialog), {
        modelValue: _unref(OverlayStore).ConfirmClose,
        "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => _unref(OverlayStore).ConfirmClose = $event),
        "close-on-press-escape": false,
        "show-close": false,
        "append-to-body": true,
        "modal-class": "configurator-popup",
        width: "808px",
        center: true
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_71, [_cache[47] || (_cache[47] = _createElementVNode("div", {
          class: "ic"
        }, [_createElementVNode("i", {
          class: "iconfont icon-info"
        })], -1)), _createElementVNode("div", _hoisted_72, [_createElementVNode("div", _hoisted_73, [_unref(OverlayStore).getConfirmType == 'f5' ? (_openBlock(), _createElementBlock("h3", _hoisted_74, _toDisplayString(_ctx.$t("header.dialog.f5close")), 1)) : _createCommentVNode("", true), _unref(OverlayStore).getConfirmType == 'switch' ? (_openBlock(), _createElementBlock("h3", _hoisted_75, _toDisplayString(_ctx.$t("header.dialog.switchClose")), 1)) : _createCommentVNode("", true), _unref(OverlayStore).getConfirmType == 'resetConfigurator' ? (_openBlock(), _createElementBlock("h3", _hoisted_76, _toDisplayString(_ctx.$t("header.dialog.resetClose")), 1)) : _createCommentVNode("", true), _unref(OverlayStore).getConfirmType == 'f5' ? (_openBlock(), _createElementBlock("div", _hoisted_77, _toDisplayString(_ctx.$t("text.dialog.f5closeText")), 1)) : _createCommentVNode("", true), _unref(OverlayStore).getConfirmType == 'switch' ? (_openBlock(), _createElementBlock("div", _hoisted_78, _toDisplayString(_ctx.$t("text.dialog.switchCloseText")), 1)) : _createCommentVNode("", true), _unref(OverlayStore).getConfirmType == 'resetConfigurator' ? (_openBlock(), _createElementBlock("div", _hoisted_79, _toDisplayString(_ctx.$t("text.dialog.resetCloseText")), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_80, [_unref(OverlayStore).getConfirmType == 'f5' ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "wikaButtonConf",
          "data-colour": "white",
          "data-no-border": "",
          id: "f5CancelButton",
          onClick: _cache[18] || (_cache[18] = () => _unref(OverlayStore).setConfirmClose(false)),
          "data-text": _ctx.$t('button.cancelf5'),
          "data-type": "button"
        }, _toDisplayString(_ctx.$t("button.cancelf5")), 9, _hoisted_81)) : _createCommentVNode("", true), _unref(OverlayStore).getConfirmType == 'switch' ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "wikaButtonConf",
          "data-colour": "white",
          "data-no-border": "",
          id: "switchCancelButton",
          onClick: _cache[19] || (_cache[19] = () => _unref(OverlayStore).setConfirmClose(false)),
          "data-text": _ctx.$t('button.cancelSwitch'),
          "data-type": "button"
        }, _toDisplayString(_ctx.$t("button.cancelSwitch")), 9, _hoisted_82)) : _createCommentVNode("", true), _unref(OverlayStore).getConfirmType == 'resetConfigurator' ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "wikaButtonConf",
          "data-colour": "white",
          "data-no-border": "",
          id: "resetConfiguratorCancelButton",
          onClick: _cache[20] || (_cache[20] = () => _unref(OverlayStore).setConfirmClose(false)),
          "data-text": _ctx.$t('button.cancelresetConfigurator'),
          "data-type": "button"
        }, _toDisplayString(_ctx.$t("button.cancelresetConfigurator")), 9, _hoisted_83)) : _createCommentVNode("", true), _unref(OverlayStore).getConfirmType == 'f5' ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "wikaButtonConf",
          "data-colour": "blue",
          "data-no-border": "",
          "data-text": _ctx.$t('button.okf5'),
          id: "f5Button",
          "data-type": "button",
          onClick: _cache[21] || (_cache[21] = () => {
            _unref(OverlayStore).setConfirmClose(false);
            if (_unref(OverlayStore).IsconfirmCloseCalled) {
              _unref(OverlayStore).setconfirmCloseCalled(true);
            } else {
              _unref(directLogout)();
            }
          })
        }, _toDisplayString(_ctx.$t("button.okf5")), 9, _hoisted_84)) : _createCommentVNode("", true), _unref(OverlayStore).getConfirmType == 'switch' ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: "wikaButtonConf",
          "data-colour": "blue",
          "data-no-border": "",
          id: "switchButton",
          "data-text": _ctx.$t('button.okSwitch'),
          "data-type": "button",
          onClick: _cache[22] || (_cache[22] = () => {
            resetMainProduct();
            _unref(OverlayStore).setconfirmCloseCalled(true);
            _unref(OverlayStore).setConfirmClose(false);
          })
        }, _toDisplayString(_ctx.$t("button.okSwitch")), 9, _hoisted_85)) : _createCommentVNode("", true), _unref(OverlayStore).getConfirmType == 'resetConfigurator' ? (_openBlock(), _createElementBlock("div", {
          key: 5,
          class: "wikaButtonConf",
          "data-colour": "blue",
          "data-no-border": "",
          id: "resetConfiguratorButton",
          "data-text": _ctx.$t('button.okResetConfigurator'),
          "data-type": "button",
          onClick: _cache[23] || (_cache[23] = () => {
            _unref(OverlayStore).setConfirmClose(false);
            _unref(handleResetConfigurator)(_unref(eventBus));
          })
        }, _toDisplayString(_ctx.$t("button.okResetConfigurator")), 9, _hoisted_86)) : _createCommentVNode("", true)])])])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_unref(ElDialog), {
        modelValue: closeDailogVisible.value,
        "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => closeDailogVisible.value = $event),
        "destroy-on-close": "",
        "close-on-press-escape": false,
        "show-close": true,
        "append-to-body": true,
        "modal-class": "configurator-popup",
        width: "808px",
        center: true
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_87, [_cache[48] || (_cache[48] = _createElementVNode("div", {
          class: "ic"
        }, [_createElementVNode("i", {
          class: "iconfont icon-info"
        })], -1)), _createElementVNode("div", _hoisted_88, [_createElementVNode("div", _hoisted_89, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t("error.shortcode.title")), 1), _createElementVNode("div", _hoisted_90, _toDisplayString(_ctx.$t("error.shortcode.description")), 1)]), _createElementVNode("div", _hoisted_91, [_createElementVNode("div", {
          class: "wikaButtonConf",
          "data-colour": "blue",
          "data-no-border": "",
          onClick: _cache[25] || (_cache[25] = () => _unref(OverlayStore).setshowShortcodeError(false)),
          "data-text": _ctx.$t('button.ok'),
          "data-type": "button"
        }, _toDisplayString(_ctx.$t("button.ok")), 9, _hoisted_92)])])])]),
        _: 1
      }, 8, ["modelValue"])], 64);
    };
  }
});